// Helper functions for working with exam data structure

//Flatten exam measurements to flat structure for compatibility
export function flattenExam(exam) {
    if (!exam) return {}
    
    const measurements = exam.measurements || {}
    const lv = measurements.lv || {}
    const mitral = measurements.mitral || {}
    
    return {
        // Metadata
        id: exam.id,
        patientId: exam.patientId,
        patientNameSnapshot: exam.patientNameSnapshot,
        doctorId: exam.doctorId,
        doctorNameSnapshot: exam.doctorNameSnapshot,
        dateConsult: exam.dateConsult,
        dataConsult: exam.dateConsult, // backward compatibility
        status: exam.status,
        locked: exam.locked,
        createdAt: exam.createdAt,
        updatedAt: exam.updatedAt,
        savedAt: exam.updatedAt, // backward compatibility
        
        // Conclusion
        concluzii: exam.conclusion,
        
        // Left Ventricle
        DTDVS: lv.dtdvs || '',
        DTDVSbsa: lv.dtdvsBsa || '',
        DTSVS: lv.dtsvs || '',
        DTSVSbsa: lv.dtsvsBsa || '',
        SIVd: lv.sivd || '',
        PPVSd: lv.ppvsd || '',
        MasaVS: lv.masaVs || '',
        RTW: lv.rtw || '',
        VTDVS: lv.vtdvs || '',
        VTDVSbsa: lv.vtdvsBsa || '',
        VTSVS: lv.vtsvs || '',
        VTSVSbsa: lv.vtsvsBsa || '',
        FEvol: lv.feVol || '',
        FS: lv.fs || '',
        FE: lv.fe || '',
        MAPSE: lv.mapse || '',
        
        // Mitral
        DPmaxMitral: mitral.dpMax || '',
        DPmediuMitral: mitral.dpMediu || '',
        VmaxMitral: mitral.vMax || '',
        SOMMitral: mitral.som || '',
        PHTMitral: mitral.pht || '',
        SOM20Mitral: mitral.som20 || '',
        dpdtMitral: mitral.dpdt || '',
        
        // Backward compatibility fields
        cnpPacient: exam.patientId,
        numePacient: exam.patientNameSnapshot,
    }
}

 //Convert array of exams to flattened format
export function flattenExams(exams) {
    if (!Array.isArray(exams)) return []
    return exams.map(flattenExam)
}

//Get exam status label
export function getStatusLabel(status) {
    const labels = {
        draft: 'Draft',
        final: 'Finalizat',
        void: 'Anulat'
    }
    return labels[status] || status
}

//Get exam status severity for PrimeVue Badge
export function getStatusSeverity(status) {
    const severities = {
        draft: 'warn',
        final: 'success',
        void: 'danger'
    }
    return severities[status] || 'info'
}
